import React, { Fragment, useEffect, useState } from "react";
import { Edit } from "react-feather";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Table,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import axiosInstance from "../../utils/axios";
import { useSelector } from "react-redux";

const PromotionList = () => {
    const navigate = useNavigate();

    // Get userType and merchantId from localStorage
    const userType = localStorage.getItem("userType");
    const loggedInMerchantId = localStorage.getItem("MerchantId");

    const [isFetching, setIsFetching] = useState(false);
    const [promotions, setPromotions] = useState([]);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0,
    });
    const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
    const selectedMerchant = userType === "merchant" ? loggedInMerchantId : reduxSelectedMerchant;

    const fetchPromotions = async () => {
        setIsFetching(true);
        try {
            const merchantId = (selectedMerchant && selectedMerchant !== 'all') ? selectedMerchant : null;
            const response = await axiosInstance.get("/api/promotion/getAllPromotions", {
                params: {
                    pageNo: pagination.pageNo,
                    pageSize: pagination.pageSize,
                    merchantID: merchantId,
                },
            });
            setPromotions(response.data.data.promotions || []);
            setPagination({
                pageNo: response.data.data.pageNo,
                pageSize: response.data.data.pageSize,
                totalRecords: response.data.data.totalRecords,
                totalPages: response.data.data.totalPages,
            });
        } catch (error) {
            console.error("Error fetching promotions:", error.response?.data || error);
            setPromotions([]);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        fetchPromotions();
    }, [pagination.pageNo, selectedMerchant]);

    const handlePageChange = (newPage) => {
        setPagination((prev) => ({ ...prev, pageNo: newPage }));
    };

    return (
        <Fragment>
            <Breadcrumb title="Promotion List" parent="Promotions" />
            <Container fluid={true}>
                <Row>
                    <Col className="d-flex justify-content-end align-items-center gap-3" style={{ marginBottom: "30px" }}>
                        <Button
                            color="primary"
                            style={{
                                padding: "10px 20px",
                                fontSize: "16px",
                                borderRadius: "5px",
                            }}
                            onClick={() => navigate("/promotion/add-promotion")}
                        >
                            Create New Promotion
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                {isFetching ? (
                                    <div>Loading promotions...</div>
                                ) : promotions.length === 0 ? (
                                    <div>No promotions found</div>
                                ) : (
                                    <Table responsive>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Image</th>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Featured</th>
                                                <th>Active</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {promotions.map((promo) => (
                                                <tr key={promo.id} style={{ verticalAlign: "middle" }}>
                                                    <td>{promo.id}</td>
                                                    <td>
                                                        <img
                                                            alt="promotion"
                                                            src={
                                                                promo.image
                                                                    ? `${process.env.REACT_APP_URL}${promo.image}`
                                                                    : "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png"
                                                            }
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = "https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/camera-512.png";
                                                            }}
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                borderRadius: "5px",
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{promo.promotionName}</td>
                                                    <td>{promo.description || "N/A"}</td>
                                                    <td>{new Date(promo.startDate).toLocaleDateString()}</td>
                                                    <td>{new Date(promo.endDate).toLocaleDateString()}</td>
                                                    <td>
                                                        {promo.isFeatured ? (
                                                            <span style={{ color: "#008000" }}>Yes</span>
                                                        ) : (
                                                            <span style={{ color: "#ff0000" }}>No</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {promo.active ? (
                                                            <span style={{ color: "#008000" }}>Yes</span>
                                                        ) : (
                                                            <span style={{ color: "#ff0000" }}>No</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Button
                                                            color="btn"
                                                            type="button"
                                                            onClick={() => navigate(`/promotion/edit-promotion/${promo.id}`)}
                                                        >
                                                            <Edit
                                                                className="editBtn"
                                                                style={{ width: "16px", height: "16px" }}
                                                            />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                )}
                                {promotions.length > 0 && (
                                    <div className="d-flex justify-content-between mt-3">
                                        <Button
                                            disabled={pagination.pageNo === 1}
                                            onClick={() => handlePageChange(pagination.pageNo - 1)}
                                        >
                                            Previous
                                        </Button>
                                        <span>
                                            Page {pagination.pageNo} of {pagination.totalPages}
                                        </span>
                                        <Button
                                            disabled={pagination.pageNo === pagination.totalPages}
                                            onClick={() => handlePageChange(pagination.pageNo + 1)}
                                        >
                                            Next
                                        </Button>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default PromotionList;